// IDS-7053 caption keys, renamed to the cof.componentmapping.* namespace in Caption Merger. Requires
// an updated co-addin-captions package build; the installed dist does not yet contain this namespace.
export const CAPTION_OUTLINE_CHANGE_COMPONENT_SOURCE = "cof.componentmapping.button.componentmapping";
export const CAPTION_CHANGE_COMPONENT_SOURCE_NO_INSTANCES = "cof.componentmapping.message.warning.noinstances";

// IDS-7054 caption keys, renamed to the cof.componentmapping.* namespace in Caption Merger. Requires
// an updated co-addin-captions package build; the installed dist does not yet contain this namespace.
export const CAPTION_CHANGE_COMPONENT_SOURCE_MASTER_SECTION = "cof.componentmapping.componetsrootdocuments";
export const CAPTION_CHANGE_COMPONENT_SOURCE_SHOW_INSTANCES = "cof.componentmapping.button.showinstances";
export const CAPTION_CHANGE_COMPONENT_SOURCE_HIDE_INSTANCES = "cof.componentmapping.button.hideinstances";

// IDS-7055 caption keys, renamed to the cof.componentmapping.* namespace in Caption Merger. Requires
// an updated co-addin-captions package build; the installed dist does not yet contain this namespace.
export const CAPTION_COMPONENT_SOURCE_SELECT_SOURCE = "cof.componentmapping.selectsource";
export const CAPTION_COMPONENT_SOURCE_SELECT_SOURCE_MESSAGE = "cof.componentmapping.selectsource.message";
export const CAPTION_COMPONENT_SOURCE_NEW_SOURCE = "cof.componentmapping.newsource";
export const CAPTION_COMPONENT_SOURCE_UNDO_CHANGE = "cof.componentmapping.button.undochange";
export const CAPTION_CHANGE_COMPONENT_SOURCE_MISSING_DOCUMENT = "cof.componentmapping.missingdocument";
export const CAPTION_CHANGE_COMPONENT_SOURCE_LEGACY_INSTANCES = "cof.componentmapping.message.warning.legacyinstances";
// Caption Merger English text: "The document is associated with an outdated metadata version and cannot be used
// to update instance sources. To migrate it to the latest metadata version, run an Update, create a Copy, or
// perform an Export/Import operation."
export const CAPTION_CHANGE_COMPONENT_SOURCE_OUTDATED_VERSION = "cof.componentmapping.message.warning.outdateversion";
export const CAPTION_APPLY = "cof.base.apply";

// IDS-7234 caption keys for the APPLY request outcome.
export const CAPTION_COMPONENT_MAPPING_APPLY_FAILED_TITLE = "cof.componentmapping.title.applyfailed";
export const CAPTION_COMPONENT_MAPPING_APPLY_FAILED_MESSAGE = "cof.componentmapping.message.error.applyfailed";
export const CAPTION_COMPONENT_MAPPING_APPLY_COMPLETED_TITLE = "cof.componentmapping.title.applycompleted";
export const CAPTION_COMPONENT_MAPPING_APPLY_COMPLETED_MESSAGE = "cof.componentmapping.message.info.applycompleted";
export const CAPTION_COMPONENT_MAPPING_APPLY_WARNING_TITLE = "cof.componentmapping.title.applywarning";
export const CAPTION_COMPONENT_MAPPING_NOT_ALL_UPDATED_MESSAGE = "cof.componentmapping.message.error.notallupdated";

// IDS-7053 "Tools" dropdown key ("Tools" / "Strumenti"). Requires an updated co-addin-captions package
// build; the installed dist only has cof.base.settings, not this key.
export const CAPTION_BASE_TOOLS = "cof.base.tools";

export const CAPTION_OUTLINE_CHANGE_TEMPLATE = "cof.opendocuments.outline.changetemplate";
export const CAPTION_CHANGE_TEMPLATE_TITLE = "cof.opendocuments.changetemplate.title";
export const CAPTION_CHANGE_TEMPLATE_SELECT_DOCUMENTS = "cof.opendocuments.changetemplate.selectdocuments";
export const CAPTION_CHANGE_TEMPLATE_INFO_DOC_SELECTION = "cof.opendocuments.changetemplate.infodocselection";
export const CAPTION_CHANGE_TEMPLATE_TEMPLATE_LABEL = "cof.opendocuments.changetemplate.templatelabel";
export const CAPTION_CHANGE_TEMPLATE_CONFIRM_TITLE = "cof.opendocuments.changetemplate.confirm.title";
export const CAPTION_CHANGE_TEMPLATE_CONFIRM_BODY = "cof.opendocuments.changetemplate.confirm.body";
export const CAPTION_CHANGE_TEMPLATE_REQUESTED_TITLE = "cof.opendocuments.changetemplate.requested.title";
export const CAPTION_CHANGE_TEMPLATE_REQUESTED_MESSAGE = "cof.opendocuments.changetemplate.requested.message";

// IDS-7635 tooltip shown on the disabled "Change Style Template" tools entry when the document root is
// in the Submitted workflow status. Requires an updated co-addin-captions package build.
export const CAPTION_CHANGE_TEMPLATE_DISABLED_SUBMITTED = "cof.opendocuments.outline.changetemplate.disabled.submitted";

// Tooltip on the disabled Template field (Advanced tab, AdvancedDocumentPanel.tsx) while the document
// is being edited. English text: "Go to OPEN > Settings to change the template for the document root
// and all document parts"
export const CAPTION_ADVANCED_TEMPLATE_DISABLED_TOOLTIP =
  "cof.documentmanagement.outline.edit.advanced.template.disabled.tooltip";

export const CAPTION_ADVANCED_TEMPLATE_INFO_EDITMESSAGE = "cof.createnewdocument.template.info.editmessage";

// Reused caption key, already available in co-addin-captions from other pages.
export const CAPTION_SHOW_MORE = "cof.documentslist.showmore";
